import { default as on_site } from ":src/modules/support/on-site/routes";
import { default as help } from ":src/modules/help-center/routes";
import { default as profile } from ":src/modules/profile/routes";
export default {
  BASE: "/support",
  on_site,
  help,
  profile,
};
